// SEO indexing policy for programmatic affordable-housing pipeline pages.
//
// The pipeline generates one page per developer (249 of them). The vast majority
// are single-project SPEs/LLCs with thin, near-duplicate content — Google leaves
// them as "Crawled/Discovered – currently not indexed" or "Duplicate without
// user-selected canonical," which drags down crawl budget for the whole domain.
//
// We index only substantial, real multi-project developers (>= 6 projects in the
// CTCAC pipeline, excluding the "TBD SPE" placeholder). Every other developer page
// is still fully browsable in the tool, but carries <meta name="robots" content="noindex">
// and is excluded from the sitemap so Google focuses on pages that can actually rank.
//
// County pages (real search intent) and the pipeline hub remain indexed.

export const INDEXED_DEVELOPER_SLUGS = [
    'pacific-west-communities-inc',
    'hvn-development-llc',
    'eden-housing-inc',
    'national-community-renaissance-of-california',
    'crp-affordable-housing-and-community-development-l',
    'chelsea-investment-corporation',
    'affirmed-housing-group-inc',
    'meta-development-llc',
    'mercy-housing-california',
    'danco-communities',
    'usa-multi-family-development-inc',
    'midpen-housing-corporation',
    'self-help-enterprises',
    'wakeland-housing-and-development-corporation',
    'linc-housing-corporation',
    'housing-authority-of-the-county-of-kern',
    'community-housingworks',
    'bridge-housing-corporation',
    'alliance-property-group-inc',
    'abode-communities',
    'eah-inc',
    'mirka-investments-llc',
    'jamboree-housing-corporation',
    'two-worlds-developer-limited-partnership',
    'dawson-holdings-inc',
];

const INDEXED_DEVELOPER_SET = new Set(INDEXED_DEVELOPER_SLUGS);

export const isDeveloperIndexed = (slug) => INDEXED_DEVELOPER_SET.has(slug);
